import { createContext, useState, useCallback } from 'react';
import { translations, languages, defaultLanguage } from './translations';

export const I18nContext = createContext(null);

const STORAGE_KEY = 'family_dkp_language';

// 从 localStorage 获取保存的语言
function getSavedLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && languages.some(l => l.code === saved)) {
      return saved;
    }
  } catch (e) {
    console.warn('Failed to get saved language:', e);
  }
  return defaultLanguage;
}

// 保存语言到 localStorage
function saveLanguage(code) {
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch (e) {
    console.warn('Failed to save language:', e);
  }
}

export function I18nProvider({ children }) {
  const [language, setLanguageState] = useState(getSavedLanguage);

  // 设置语言并保存到 localStorage
  const setLanguage = useCallback((code) => {
    if (languages.some(l => l.code === code)) {
      setLanguageState(code);
      saveLanguage(code);
    }
  }, []);

  // 获取翻译文本的函数
  const t = useCallback((key) => {
    const translation = translations[language]?.[key];
    if (translation === undefined) {
      // 如果找不到翻译，回退到默认语言
      const fallback = translations[defaultLanguage]?.[key];
      if (fallback === undefined) {
        console.warn(`Translation missing for key: ${key}`);
        return key;
      }
      return fallback;
    }
    return translation;
  }, [language]);

  // 获取当前语言信息
  const currentLanguage = languages.find(l => l.code === language) || languages[0];

  const value = {
    language,
    setLanguage,
    t,
    currentLanguage,
    languages,
  };

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}